import { Component, Input } from '@angular/core';

@Component({
  selector: 'nx-ng-success-indicator',
  templateUrl: './success-indicator.component.html',
  styleUrls: ['./success-indicator.component.scss']
})
export class SuccessIndicatorComponent {

  @Input()
  labelKey = "";
}
